<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline :title="getTitle">
        <v-card-actions>
          <!-- <router-link slot="right" :to="{ name: 'SystemRoles' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>Back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link> -->
        </v-card-actions>
        <v-card flat class="px-2">
          <form autocomplete="off" @submit.prevent="saveRoles">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Role Name
                  </label>
                  <v-select class="my-1 py-0" placeholder="--SELECT" v-model="userObj.roleName" multiple :items="rolesList" light item-text="role" item-value="role">
                  <template v-slot:selection="{ item }">
                    <v-chip small dark class="font-weight-medium" color="darkblue lighten-1">
                      <span>{{ item.role }}</span>
                    </v-chip>
                  </template>
                </v-select>

              </v-col>
              <!-- <v-col cols="12" md="3">
                    <label class="font-weight-medium body-2">isActive</label>
                    <v-switch v-model="userObj.isActive" :label="userObj.isActive? 'true' : 'false'" color="primary"></v-switch>
              </v-col> -->
              <v-col cols="12" md="3">
                <v-card-actions class="d-flex justify-center">
                  <v-btn bottom right elevation="1" color="primary" type="submit" class="add-btn">
                    <v-icon left> mdi-content-save </v-icon>
                    Add
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
           <v-card-title>
              Roles List
            <v-spacer></v-spacer>
          </v-card-title>
           <v-divider class=" my-0 " />

        <v-data-table
          :footer-props="{
          'items-per-page-options': [5, 10, 20, 40] }"
          :items-per-page="4"
          :headers="headers"
          :items="roles"
          disable-pagination
          :hide-default-footer="true"
          item-key="srno"
        >
        <!-- <template v-slot:item.srno="{ item }"> {{ item.srno }} </template> -->
        <template v-slot:[`item.roleName`]="{ item }">
            <span class="text-capitalize">{{ item.roleName}} </span>
          </template>

          <template v-slot:[`item.isActive`]="{ item }">
            {{ item.isActive ? 'Active' : 'Inactive' }}
          </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small v-if="!item.deletedAt" @click.prevent="deleteRole(item)">
              <v-icon small> mdi-delete</v-icon>
            </v-btn>
            </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
                <!--Pagination start-->
        <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="totalPages"
              @input="handlePageChange">
            </v-pagination>
          </v-col>
        </v-row>
        <!--Pagination end-->
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
// import moment from 'moment'

// import _ from 'lodash'

export default {
  name: 'addRoles',
  components: {
    MaterialCard
  },
  props: {
    checkable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      getTitle: 'Add Access Levels',
      isActive: false,
      roles: [],
      rolesList: [],
      resultArray: [],
      role: '',
      selectedroleID: [],
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      totalPages: 0,
      loadingComponent: null,
      userObj: {
        roleName: [],
        isActive: true
        // role: []
      },
      tags: {
        GET: 'has-text-primary',
        PUT: 'has-text-link',
        POST: 'has-text-success',
        DELETE: 'has-text-danger'
      },
      headers: [
        { text: 'Sr No', value: 'srno', align: 'center', sortable: true },
        { text: 'Roles', value: 'roleName', sortable: true },
        { text: 'Status', value: 'isActive', sortable: true },
        { text: 'Action', value: 'actions', sortable: false }
      ]

    }
  },

  async created () {
    await this.getAllRoleList()
    await this.getRoleList()
  },
  beforeDestroy () {
    let elements = document.getElementsByClassName('vuedl-layout__closeBtn')
    if (elements.length > 0) {
      elements[0].click()
    }
  },
  methods: {
    getRoleList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/sop-module/allroles`, {
          params: {
            page: this.page - 1,
            size: this.pageSize
          }
        })
        this.roles = res.data.rows.map((item, index) => {
          // item.srno = index + 1
          item.srno = this.pageSize * (this.page - 1) + index + 1
          return item
        })
        this.totalPages = res.data.totalPages
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getAllRoleList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/roles`)
        // console.log(data, 'testing')

        this.rolesList = data
        // console.log(this.rolelist, '20')
        this.isLoading = false

        return this.rolesList
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching role', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    saveRoles: async function () {
      let roleCount = null

      if (this.userObj.roleName.length > 1) {
        roleCount = 'Roles'
      } else {
        roleCount = 'Role'
      }

      if (this.userObj.roleName.length === 0) {
        this.errMsg("Kindly select Role's value!!")
        return false
      }
      try {
        this.isLoading = true
        await http.post(`${constants.API_URL}/api/sop-module/addroles`, this.userObj)
        // console.log(this.userObj, 'test5')
        this.okMsg(`${roleCount} updated successfully!`)
        this.getRoleList()
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
        this.userObj.roleName = []
      }
    },
    deleteRole: function (item) {
      let that = this
      // console.log('trigged')
      this.$dialog.warning({
        title: item.isActive === true ? 'Deactivate' : 'Activate',
        text: 'Are you sure you want to delete this Role?',
        actions: {
          // false: {
          //   // text: 'No',
          //   handle: () => {
          //     return false
          //   }
          // },
          true: {
            color: 'success',
            text: 'Yes',

            handle: async () => {
              try {
                this.isLoading = true
                return http.put(`${constants.API_URL}/api/sop-module/roles/${item.id}`, {
                  isActive: item.isActive,
                  roleName: item.roleName
                }).then(() => {
                  that.getRoleList()
                  this.isLoading = false
                  return this.$dialog.info({
                    title: 'Success',
                    text: 'Role Deleted successfully.'

                  })
                })
              } catch (httpException) {
                console.warn('Error while deleting Role', httpException.message)
                this.isLoading = false

                return this.$dialog.error({
                  title: 'Error',
                  text: 'Error while Deleting Role'
                })
              } finally {
                this.isLoading = false
              }
            }
          } }
      })
    },
    handlePageChange: function () {
      console.log(`Page: ${this.page}`)
      this.getRoleList()
    },
    handlePageSizeChange: function () {
      console.log(`Page Size: ${this.pageSize}`)
      this.getRoleList()
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}

</script>
<style>
  .add-btn{
    margin-top: 15px;
  }
</style>
